"use strict";

module.exports = function (h, that) {
  var perpageValues = [];

  that.opts.perPageValues.every(function (value) {
    var isLastEntry = value >= that.count;
    var selected = that.limit == value || isLastEntry && that.limit > value;
    perpageValues.push(h(
      "option",
      {
        attrs: { value: value, selected: selected }
      },
      [value]
    ));
    return !isLastEntry;
  });

  return perpageValues;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/template/per-page-values.js
// module id = 294
// module chunks = 0